export default __webpack_public_path__ + "static/media/peak10.0c670c50.png";